import {
  ArrowLeftIcon,
  ArrowRightIcon,
  Button,
  DatePicker,
  Grid,
  GridColumn,
  GridRow,
  LazyLoader,
} from '@bp/ui-components';
import { BpCard } from 'components/BpCard/BpCard';
import { Timetable } from 'components/Timetable/Timetable';
import dayjs, { Dayjs } from 'dayjs';
import { useIsDesktop } from 'hooks/useIsDesktop';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HomeworkList } from '../HomeworkList/HomeworkList';
import styles from './HomeworkGrid.module.scss';

type HomeworkGridProps = {
  profileUuid: string;
};

export const HomeworkGrid = ({ profileUuid }: HomeworkGridProps) => {
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();

  const [selectedDay, setSelectedDay] = useState<Dayjs>(dayjs());

  return (
    <Grid className={styles['homework-grid']}>
      <GridRow mobileGap='var(--grid-column-gap)'>
        <GridColumn width={4}>
          {isDesktop ? (
            <BpCard>
              <Timetable
                profileUuid={profileUuid}
                context='homework'
                showDaySelect
                showLegend
                hideTodayHighlight
                noFuture
                days={1}
                selectedDay={selectedDay}
                setSelectedDay={setSelectedDay}
                eventColorSource='subject'
              />
            </BpCard>
          ) : (
            <div className={styles.actions}>
              <div className={styles.date}>
                <Button
                  name='decrease'
                  hierarchy='tertiary'
                  onClick={() => {
                    const newDate = selectedDay.subtract(1, 'day');
                    setSelectedDay(newDate);
                  }}
                  icon={<ArrowLeftIcon />}
                />
                <DatePicker
                  className={styles.picker}
                  onChange={(e) => {
                    const newDate = dayjs(e);
                    setSelectedDay(newDate);
                  }}
                  name='date'
                  value={selectedDay.toDate()}
                  maxDate={new Date()}
                  dense
                />
                <Button
                  name='increase'
                  hierarchy='tertiary'
                  disabled={selectedDay.isSameOrAfter(dayjs(), 'days')}
                  onClick={() => {
                    const newDate = selectedDay.add(1, 'day');
                    setSelectedDay(newDate);
                  }}
                  icon={<ArrowRightIcon />}
                />
              </div>
              <Button
                className={styles.today}
                hierarchy='secondary'
                onClick={() => {
                  const newDate = dayjs();
                  setSelectedDay(newDate);
                }}
                disabled={selectedDay.isSame(dayjs(), 'day')}
              >
                {t('common.today')}
              </Button>
            </div>
          )}
        </GridColumn>
        <GridColumn width={8}>
          <Suspense fallback={<LazyLoader embedded transparent forceHeight='50vh' />}>
            <HomeworkList profileUuid={profileUuid} selectedDay={selectedDay} />
          </Suspense>
        </GridColumn>
      </GridRow>
    </Grid>
  );
};
